<div mat-dialog-title class="dialog-title" id="confirmTitle">{{ 'Alert.AlertDefaultsSettings.InfoHeader' | translate: locale.language }}</div>
<div mat-dialog-content>
  <div>
    {{ 'Alert.AlertDefaultsSettings.InfoText' | translate: locale.language }}
  </div>
  @if (isLoading || errorResponse) {
    <div style="min-height: 8px; margin-top: 0.5rem;">
      <app-loading id="alert-loading" [hasFailed]="errorResponse" (retryClicked)="getData()"
        [failTitle]="errorMessage" [isCircle]="true" [hasLoaded]="!isLoading">
      </app-loading>
    </div>
  }
  <!-- table goes here -->
  @if (!isLoading && !errorResponse) {
    <mat-table #table [dataSource]="dataSource">
      <ng-container matColumnDef="channel">
        <mat-header-cell *matHeaderCellDef>Channel</mat-header-cell>
        <mat-cell *matCellDef="let element">{{element.channelName}}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="emergency">
        <mat-header-cell *matHeaderCellDef>Emergency</mat-header-cell>
        <mat-cell *matCellDef="let element">
          @if (element.channelEnabledForEmergency) {
            <mat-icon>done</mat-icon>
            <span class="cdk-visually-hidden">{{ element.channelName }} on for emergency alerts</span>
          }
          @if (!element.channelEnabledForEmergency) {
            <mat-icon>close</mat-icon>
            <span class="cdk-visually-hidden">{{ element.channelName }} off for emergency alerts</span>
          }
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="nonEmergency">
        <mat-header-cell *matHeaderCellDef>Non-emergency</mat-header-cell>
        <mat-cell *matCellDef="let element">
          @if (element.channelEnabledForNonEmergency) {
            <mat-icon>done</mat-icon>
            <span class="cdk-visually-hidden">{{ element.channelName }} on for non-emergency alerts</span>
          }
          @if (!element.channelEnabledForNonEmergency) {
            <mat-icon>close</mat-icon>
            <span class="cdk-visually-hidden">{{ element.channelName }} off for non-emergency alerts</span>
          }
        </mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>
  }
</div>
<div mat-dialog-actions align="end">
  <button mat-button color="primary" mat-dialog-close>Close</button>
</div>